export default __webpack_public_path__ + "e7c39c8df023bbad4e0fa90749aabd77.png";